// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100%\" height=\"100%\" viewBox=\"0 0 20 20\"> <path d=\"M19.242.758l-6.57 18.199a.557.557 0 01-1.011 0l-3.535-7.078-7.083-3.538a.557.557 0 010-1.01l18.2-6.573M8.16 11.895l2.55-2.607L19.197.851\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.515075\"/> </svg>";
// Exports
module.exports = code;